module.exports = __webpack_public_path__ + "img/external-link-symbol.59c1aa53.svg";